export default __webpack_public_path__ + "static/B0198-3d4890c10cb4e9cc611653aed1f2a8d3.png";